// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"P0-z","displaySixCardTiles":"Q0-z"};